﻿import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ValidationMessage } from "../../validation/validationMessage";
import { ValidationMessageType } from "../../validation/validationMessageType";


@Component({
    selector: "jax-combobox",
    inputs: ["label", "showLabel", "inputLabelResourceKey", "itemsSource", "selectedValue", "displayMemeberName", "selectedValuePropertyName", "propertyDisplayName", "propertyName", "isDisabled", "isMandatory", "validate", "validators"],
    templateUrl: "./comboBox.component.html"
})

export class ComboBoxComponent {
    public isDisabled: boolean;
    public displayMemeberName: string;
    public selectedValue: any;
    public inputLabelResourceKey;
    public isMandatory: boolean;
    public selectedValuePropertyName: string;
    public showLabel: string = "true";
    private inputLabel;
    private _itemsSource;
    public propertyName: string;
    public propertyDisplayName: string;

    @Input() validationMessage: any;
    @Output() selectedValueChange: any = new EventEmitter();

    public get itemsSource() {
        return this._itemsSource;
    }
    public set itemsSource(value) {
        this._itemsSource = value;
    }

    public selectedItemChange(value) {
        this.selectedValue = value;
        if (value) {
            this.validateValue(value);
        }
        this.selectedValueChange.emit(value);
    }

    public validateValue($event: any): void {
        if (this.selectedValue == -1) {

            let vm = new ValidationMessage();
            vm.message = this.propertyDisplayName + " is required.";
            vm.propertyName = this.propertyDisplayName;
            vm.messageType = ValidationMessageType.Error;

            this.validationMessage = vm;
        }
        else
        {
            this.validationMessage = null;
        }
    }
}